// Page servie quand l'IP du visiteur n'est pas dans SUPERADMIN_IP_ALLOWLIST.
// Volontairement minimale et neutre : pas de mention "panel", pas de logo,
// pas d'aide à l'orientation. Un visiteur non autorisé doit avoir le moins
// d'info possible. Le user remplacera ce placeholder par une "belle image"
// plus tard — voir AGENTS.md.

import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "Nope",
  robots: { index: false, follow: false, nocache: true },
};

export default function NopePage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 text-center">
      <div className="max-w-md">
        <p className="text-6xl font-light tracking-tight text-foreground">
          nope.
        </p>
        <p className="mt-4 text-sm text-muted-foreground">
          Cette adresse n&apos;est pas accessible depuis votre réseau.
        </p>
      </div>
    </main>
  );
}
